import React from 'react';
import { get, map, isEqual } from 'lodash';

// local dependencies
import { entityInfoCells as EntityInfoCells } from 'ui/views/widgets/entityInfoCells';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { button as Button } from 'modules/button';
import { entityConfig } from 'config/entity-info/to-do-detail-summary';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { toDoItemDetailSummaryWidget as ToDoItemDetailSummaryWidget } from 'ui/views/toDoItemDetailSummaryWidget';
 *
 * // render
 * <ToDoItemDetailSummaryWidget propName='propValue'/>
 */
export const _toDoItemDetailSummaryWidget = ( props ) => {
    const primarySection = get( props, 'componentData.primarySection', [] );
    const secondarySection = get( props, 'componentData.secondarySection', [] );
    const toDoData = get( props, 'componentData.toDoData', {} );
    const actions = get( props, 'componentData.actions', [] );
    const hasPassedDueDate = get( props, 'componentData.toDoData.hasPassedDueDate', {} ) ;
    const todoStatus = get( props, 'componentData.toDoData.status', {} ) ;
    
    return (
        <div className='ui-to-do-item-detail-summary-widget'>
            <div className='ui-to-do-item-detail-summary-widget__body'>
                <div className='ui-to-do-item-detail-summary-widget__body__primary'>
                    {
                        hasPassedDueDate && ( isEqual( todoStatus, 'open' ) ) ? (
                            <EntityInfoCells
                                items= { primarySection }
                                values={ toDoData }
                                entityConfig={ entityConfig }
                                className='ui-to-do-item-detail-summary-widget__body__primary__cell'
                            />
                        ) :
                            <EntityInfoCells
                                items= { primarySection }
                                values={ toDoData }
                                entityConfig={ entityConfig }
                                className='ui-to-do-item-detail-summary-widget__body__primary__cell'
                            />
                    }
                </div>
                <div className='ui-to-do-item-detail-summary-widget__body__secondary'>
                    <div className='ui-to-do-item-detail-summary-widget__body__secondary__list'>

                        <EntityInfoCells
                            items= { secondarySection }
                            values={ toDoData }
                            entityConfig={ entityConfig }
                            className='ui-to-do-item-detail-summary-widget__body__secondary__list__cell'
                        />

                    </div>
                    <div className='ui-to-do-item-detail-summary-widget__body__secondary__actions'>
                        {
                            map( actions, action => {
                                return (
                                    <Button
                                        key={ action.name }
                                        id={ action.name }
                                        type='button'
                                        size='medium'
                                        { ...action }
                                        disabled={ false }
                                        outline={ false }
                                        onClick = { () => props.onActionClick( { value: action } ) }
                                    />
                                );
                            } )
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

// set display name
_toDoItemDetailSummaryWidget.displayName = 'toDoItemDetailSummaryWidget';

// set default props
_toDoItemDetailSummaryWidget.defaultProps = {};

// prop types
_toDoItemDetailSummaryWidget.propTypes = {};

const toDoItemDetailSummaryWidgetPreloader = ( ) => {
   
    return (
        <div className='ui-to-do-item-detail-summary-widget-preloader'>
            <div className='ui-to-do-item-detail-summary-widget-preloader__body'>
                { map( [ 1, 2 ], item => {
                    return (
                        <div className='ui-to-do-item-detail-summary-widget-preloader__body__primary' key={ item }>
                            { map( [ 1, 2, 3, 4, 5, 6 ], _item => {
                                return (
                                    <div  className='ui-to-do-item-detail-summary-widget-preloader__body__primary__cell' key={ _item }>
                                        <div className='ui-to-do-item-detail-summary-widget-preloader__body__primary__cell__title'></div>
                                        <div className='ui-to-do-item-detail-summary-widget-preloader__body__primary__cell__value'></div>
                                    </div>
                                );
                            } ) }
                        </div>
                    );
                } ) }

                <div className='ui-to-do-item-detail-summary-widget-preloader__body__primary'>
                    { map( [ 1, 2, 3 ], _item => {
                        return (
                            <div  className='ui-to-do-item-detail-summary-widget-preloader__body__primary__cell' key={ _item }>
                                <div className='ui-to-do-item-detail-summary-widget-preloader__body__primary__cell__title'></div>
                                <div className='ui-to-do-item-detail-summary-widget-preloader__body__primary__cell__value'></div>
                            </div>
                        );
                    } ) }
                </div>
            </div>
        </div>
    );
};

// set display name
toDoItemDetailSummaryWidgetPreloader.displayName = 'toDoItemDetailSummaryWidgetPreloader';

// set default props
toDoItemDetailSummaryWidgetPreloader.defaultProps = {};

// prop types
toDoItemDetailSummaryWidgetPreloader.propTypes = {};

export const toDoItemDetailSummaryWidget = withNetworkState( toDoItemDetailSummaryWidgetPreloader, _toDoItemDetailSummaryWidget );

